import {
  Backlog,
  CongestionMetrics,
  CycleBucket,
  DistanceMetrics,
  GeoDest,
  OrdersStatusRow,
  PickingKpi,
  PickingStats,
  ProcessMetrics,
  ProcessShare,
  ShiftProgress,
  SkuSnapshot,
  SlottingIndicator,
  TaskSummary,
  ThroughputPoint,
  UphCell,
  UserProductivity,
  WorkerMetric,
} from '../types/metrics';

export const mockOrdersStatus: OrdersStatusRow[] = [
  { groupKey: 'Amazon', status: 'OPEN', orderCount: 8985 },
  { groupKey: 'Amazon', status: 'IN_PROGRESS', orderCount: 24589 },
  { groupKey: 'Amazon', status: 'COMPLETED', orderCount: 33547 },
  { groupKey: 'Shopify', status: 'OPEN', orderCount: 5234 },
  { groupKey: 'Shopify', status: 'IN_PROGRESS', orderCount: 15678 },
  { groupKey: 'Shopify', status: 'COMPLETED', orderCount: 25431 },
];

export const mockTaskSummary: TaskSummary[] = [
  { groupKey: 'Picking', state: 'OPEN', volume: 967300 },
  { groupKey: 'Picking', state: 'IN_PROGRESS', volume: 922192 },
  { groupKey: 'Picking', state: 'DONE', volume: 915120 },
  { groupKey: 'Packing', state: 'OPEN', volume: 456789 },
  { groupKey: 'Packing', state: 'IN_PROGRESS', volume: 345678 },
  { groupKey: 'Packing', state: 'DONE', volume: 234567 },
];

export const mockUserProductivity: UserProductivity[] = [
  { userId: 'Worker1', completedTasks: 450, avgHandleSec: 120 },
  { userId: 'Worker2', completedTasks: 380, avgHandleSec: 145 },
  { userId: 'Worker3', completedTasks: 520, avgHandleSec: 95 },
  { userId: 'Worker4', completedTasks: 410, avgHandleSec: 130 },
];

export const mockSkuSnapshot: SkuSnapshot[] = [
  {
    groupKey: 'SKU-001',
    stockAvailable: 529,
    unitsShipped: 135,
    unitsPending: 3,
    trend: [10, 15, 12, 18, 20, 15, 13],
  },
  {
    groupKey: 'SKU-002',
    stockAvailable: 133,
    unitsShipped: 91,
    unitsPending: 1,
    trend: [8, 12, 15, 10, 9, 11, 14],
  },
];

export const mockCycleBuckets: CycleBucket[] = [
  {
    groupKey: '2024-03-20',
    under24: 45,
    between24And48: 30,
    between48And72: 15,
    over72: 10,
  },
  {
    groupKey: '2024-03-19',
    under24: 50,
    between24And48: 25,
    between48And72: 20,
    over72: 5,
  },
];

export const mockGeoDest: GeoDest[] = [
  { groupKey: 'TX', orders: 57, medianCycleH: 24 },
  { groupKey: 'CA', orders: 45, medianCycleH: 48 },
  { groupKey: 'NY', orders: 38, medianCycleH: 36 },
];

export const mockUphCells: UphCell[] = [
  { groupKey: 'Picking', month: '2024-03', UPH: 85, target: 100 },
  { groupKey: 'Packing', month: '2024-03', UPH: 95, target: 90 },
  { groupKey: 'Putaway', month: '2024-03', UPH: 75, target: 80 },
];

export const mockShiftProgress: ShiftProgress = {
  shiftStart: '2024-03-20T09:00:00Z',
  shiftEnd: '2024-03-20T18:00:00Z',
  tasksCompletedPct: 64,
  orderLinesPackedPct: 45,
  ordersToShipPct: 27,
};

export const mockBacklog: Backlog = {
  totalOrders: 33547,
  open: 8985,
  inProgress: 24589,
  totalProducts: 227057,
  totalAmount: 117750875,
};

export const mockWorkerMetrics: WorkerMetric[] = [
  {
    groupKey: 'Worker1',
    paidHoursProd: 8,
    workHoursProd: 7.2,
    utilisation: 90,
    efficiency: 95,
    volume: 450,
  },
  {
    groupKey: 'Worker2',
    paidHoursProd: 8,
    workHoursProd: 6.8,
    utilisation: 85,
    efficiency: 88,
    volume: 380,
  },
];

export const mockSlottingIndicators: SlottingIndicator[] = [
  {
    metric: 'Reserve Zone Compliance',
    valuePct: 62,
    thresholdPct: 80,
    status: 'BAD',
  },
  {
    metric: 'Pick Face Utilization',
    valuePct: 85,
    thresholdPct: 75,
    status: 'GOOD',
  },
];

export const mockPickingKpi: PickingKpi = {
  pulse: 75,
  utilisation: 85,
  percentOfTarget: 90,
};

export const mockThroughput: ThroughputPoint[] = [
  {
    ts: '2024-03-20T09:00:00Z',
    actual: 450,
    forecast: 500,
    goal: 550,
    typical: 480,
  },
  {
    ts: '2024-03-20T10:00:00Z',
    actual: 520,
    forecast: 510,
    goal: 550,
    typical: 490,
  },
];

export const mockPickingStats: PickingStats = {
  totalTime: '32 HR 13 MIN 41 SEC',
  totalPicks: 496,
  picklists: 105,
  linesCount: 496,
  uomCount: 933,
  pickRateNet: 54,
  pickRateGross: 41,
  uomRateNet: 101,
  uomRateGross: 77,
  avgUnitsPerLine: 1.88,
  netTime: '9 hr 13 min 8 sec',
  grossTime: '12 hr 6 min 10 sec',
  idleTime: '2 hr 53 min 2 sec',
};

export const mockProcessShare: ProcessShare[] = [
  { activityType: 'TRAVELLING START/END', percentage: 13, color: '#a3e635' },
  { activityType: 'TRAVELLING', percentage: 13, color: '#84cc16' },
  { activityType: 'LIFTING/LOWERING', percentage: 4.1, color: '#22c55e' },
  { activityType: 'PREP & STAGING', percentage: 24, color: '#14b8a6' },
  { activityType: 'PICKING (HANDLING)', percentage: 45, color: '#3b82f6' },
];

export const mockProcessMetrics: ProcessMetrics = {
  cost: 17,
  time: 2,
  travellingStartEnd: 13,
  travelling: 13,
  liftingLowering: 4.1,
  prepAndStaging: 24,
  picking: 45,
  handlingAndPicking: 69,
  travellingTotal: 31,
};

export const mockCongestionMetrics: CongestionMetrics[] = [
  { zoneId: 'Zone A', congestionLevel: 75, workerCount: 8, avgWaitTime: 45 },
  { zoneId: 'Zone B', congestionLevel: 45, workerCount: 5, avgWaitTime: 20 },
  { zoneId: 'Zone C', congestionLevel: 90, workerCount: 12, avgWaitTime: 120 },
];

export const mockDistanceMetrics: DistanceMetrics[] = [
  {
    processType: 'Picking',
    totalDistance: 2500,
    avgDistancePerTask: 25,
    timeSpent: 3600,
  },
  {
    processType: 'Putaway',
    totalDistance: 1800,
    avgDistancePerTask: 30,
    timeSpent: 2400,
  },
  {
    processType: 'Replenishment',
    totalDistance: 1200,
    avgDistancePerTask: 40,
    timeSpent: 1800,
  },
];
